import React from "react";

function SuccessMessage() {
  return (
    <>
      <div id="SuccessMessage" className="SuccessMessage">
        <h3>MOT DE PASSE MODIFIÉ AVEC SUCCÈS</h3>
        <p>
          Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.
        </p>
      </div>
      <a href="/login">{`Aller à la connexion >`}</a>
    </>
  );
}

export default SuccessMessage;
